import { useQuery } from "@apollo/client";
import { useDispatch } from "react-redux";
import { useEffect } from "react";
import { QUERY_PERMISSIONS } from "../queries/permissionsQueries";
import { setPermissions, setLoading } from "../../../state/permissionsReducer";

export function QueryPermissions(role: string) {
  const dispatch = useDispatch();
  const { data, loading, error } = useQuery(QUERY_PERMISSIONS, {
    variables: { role: role },
  });
  if (error) {
    console.log(error);
  }
  useEffect(() => {
    dispatch(setLoading(loading));
  }, [dispatch, loading]);
  useEffect(() => {
    if (data) {
      dispatch(setPermissions(data.getPermissionsForRole?.permissions?.[role]));
    }
  }, [dispatch, data, loading, error, role]);
}
